/* NailHandy — danh sách sản phẩm khách đã lưu ("Saved").
   Tầng dữ liệu duy nhất cho nút trái tim trên thẻ sản phẩm và trang /pages/saved.

   Cách lưu:
   - Khách chưa đăng nhập: localStorage, không gọi mạng, không cần app.
   - Khách đã đăng nhập: vẫn ghi localStorage trước (bấm là thấy ngay), rồi nh-wishlist-sync.js
     đẩy lên tài khoản nếu tệp đó có mặt. Tầng này không tự gọi mạng.

   Hình dạng dữ liệu (v2):
     { v: 2, items: [ { id, u: url, t: tên, i: ảnh, p: giá, ts: lúc lưu } ] }
   Bản v1 cũ chỉ là mảng mã số — được nâng cấp tại chỗ, phần thiếu do resolve() bù sau. */
(function () {
  'use strict';

  var KEY = 'nh_wishlist_v1';
  var listeners = [];
  var cache = null;

  function normalise(raw) {
    // v1: mảng mã số trần
    if (Array.isArray(raw)) {
      return raw.map(function (id) {
        return { id: String(id), ts: 0 };
      });
    }
    if (raw && Array.isArray(raw.items)) {
      return raw.items
        .filter(function (it) {
          return it && it.id;
        })
        .map(function (it) {
          return {
            id: String(it.id),
            u: it.u || '',
            t: it.t || '',
            i: it.i || '',
            p: it.p || '',
            ts: it.ts || 0,
          };
        });
    }
    return [];
  }

  function read() {
    if (cache) return cache;
    try {
      var raw = localStorage.getItem(KEY);
      cache = normalise(raw ? JSON.parse(raw) : []);
    } catch (e) {
      cache = [];
    }
    return cache;
  }

  function notify(list) {
    listeners.forEach(function (fn) {
      try {
        fn(list);
      } catch (err) {
        /* một listener hỏng không được làm chết các listener khác */
      }
    });
  }

  function write(list) {
    cache = list;
    try {
      localStorage.setItem(KEY, JSON.stringify({ v: 2, items: list }));
    } catch (e) {
      /* hết dung lượng hoặc trình duyệt chặn — nút vẫn đúng trạng thái trong phiên này */
    }
    paint(document);
    notify(list);
  }

  function indexOf(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === String(id)) return i;
    }
    return -1;
  }

  function paint(root) {
    var saved = read();
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-nh-wish]').forEach(function (btn) {
      var on = indexOf(saved, btn.dataset.nhWish) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
    });
    document.querySelectorAll('[data-nh-wish-count]').forEach(function (el) {
      // Rong (khong phai so 0) de rule :empty an badge di — giong badge gio hang cua theme.
      el.textContent = saved.length ? String(saved.length) : '';
      el.hidden = saved.length === 0;
    });
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest ? ev.target.closest('[data-nh-wish]') : null;
    if (!btn) return;
    ev.preventDefault();
    ev.stopPropagation();

    var id = String(btn.dataset.nhWish);
    var list = read().slice();
    var at = indexOf(list, id);
    if (at === -1) {
      list.push({
        id: id,
        u: btn.dataset.nhWishUrl || '',
        t: btn.dataset.nhWishTitle || '',
        i: btn.dataset.nhWishImage || '',
        p: btn.dataset.nhWishPrice || '',
        ts: Date.now(),
      });
      btn.classList.add('is-just-added');
      setTimeout(function () {
        btn.classList.remove('is-just-added');
      }, 420);
    } else {
      list.splice(at, 1);
    }
    write(list);
  });

  /* /products.json trả giá dạng chuỗi thập phân ("29.99"), khác hẳn bộ lọc `money` của Liquid.
     Quy về đúng MỘT dạng — chuỗi đã định dạng — ngay lúc ghi, để nơi hiển thị không phải đoán. */
  function formatPrice(decimal) {
    var n = Number(decimal);
    if (!isFinite(n)) return '';
    var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: code,
      }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  /* Ảnh gốc trên CDN có thể tới vài nghìn pixel; thẻ chỉ cần 400. */
  function thumb(src) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=400';
  }

  /* Bù phần thiếu (mục lưu từ bản v1 chỉ có mã số) bằng danh mục công khai của storefront.
     Chỉ tải đúng số trang cần để tìm đủ các mã còn thiếu. */
  function resolve() {
    var missing = read().filter(function (it) {
      return !it.u || !it.i;
    });
    if (!missing.length) return Promise.resolve(read());

    var want = {};
    missing.forEach(function (it) {
      want[it.id] = true;
    });

    function fetchPage(page) {
      if (page > 12 || !Object.keys(want).length) return Promise.resolve();
      return fetch('/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.ok ? r.json() : { products: [] };
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          if (!products.length) return null;
          var list = read().slice();
          var touched = false;
          products.forEach(function (p) {
            var id = String(p.id);
            if (!want[id]) return;
            delete want[id];
            var at = indexOf(list, id);
            if (at === -1) return;
            var img = p.images && p.images[0] ? p.images[0].src : '';
            var v0 = p.variants && p.variants[0];
            list[at] = {
              id: id,
              u: list[at].u || '/products/' + p.handle,
              t: list[at].t || p.title,
              i: list[at].i || thumb(img),
              p: list[at].p || (v0 ? formatPrice(v0.price) : ''),
              ts: list[at].ts,
            };
            touched = true;
          });
          if (touched) write(list);
          return fetchPage(page + 1);
        })
        .catch(function () {
          /* mạng lỗi — trang vẫn hiện được các mục đã đủ dữ liệu */
          return null;
        });
    }

    return fetchPage(1).then(function () {
      /* Mã không còn trong danh mục = sản phẩm đã gỡ bán; dọn khỏi danh sách. */
      var gone = Object.keys(want);
      if (gone.length) {
        write(
          read().filter(function (it) {
            return gone.indexOf(it.id) === -1;
          })
        );
      }
      return read();
    });
  }

  window.NHWish = {
    key: KEY,
    all: function () {
      return read().slice();
    },
    has: function (id) {
      return indexOf(read(), id) !== -1;
    },
    remove: function (id) {
      var list = read().slice();
      var at = indexOf(list, id);
      if (at !== -1) {
        list.splice(at, 1);
        write(list);
      }
    },
    /* Gộp danh sách từ nơi khác (tài khoản trên máy chủ) vào danh sách tại máy này.
       Giữ cả hai bên; mục trùng thì lấy bản có nhiều dữ liệu hơn. */
    merge: function (incoming) {
      var list = read().slice();
      var added = 0;
      (incoming || []).forEach(function (it) {
        if (!it || !it.id) return;
        var at = indexOf(list, it.id);
        if (at === -1) {
          list.push({
            id: String(it.id),
            u: it.u || '',
            t: it.t || '',
            i: it.i || '',
            p: it.p || '',
            ts: it.ts || 0,
          });
          added++;
        } else {
          ['u', 't', 'i', 'p'].forEach(function (k) {
            if (!list[at][k] && it[k]) list[at][k] = it[k];
          });
          if (!list[at].ts && it.ts) list[at].ts = it.ts;
        }
      });
      write(list);
      return added;
    },
    resolve: resolve,
    repaint: function () {
      paint(document);
    },
    subscribe: function (fn) {
      if (typeof fn === 'function') listeners.push(fn);
    },
  };

  // Vẽ lại khi thẻ mới xuất hiện (Section Rendering API, băng chuyền, bộ lọc)
  var pending = null;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = requestAnimationFrame(function () {
      pending = null;
      paint(document);
    });
  });

  function start() {
    paint(document);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Đồng bộ giữa các tab đang mở
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) {
      cache = null;
      paint(document);
      notify(read());
    }
  });
})();
